import { mapState, mapStores } from 'pinia';
import moment from 'moment';
import { defineComponent } from 'vue';
import { NButton, SelectOption, NDatePicker, NButtonGroup } from 'naive-ui';

import ComponentBase from '~/components/component-base';
import PageHeader from '~/core/components/page-header/page-header.vue';
import ExportDataModal from '~/components/modals/export-data-modal/export-data-modal.vue';

import { useStationStore } from '~/store/station.store';

import { StationGroup } from '~/api/models/station-group.model';
import { useDispatchStore } from '~/store/dispatch.store';
import { DispatchDashboardFilterEnum } from '~/models/dispatch/dispatch-dasboard-filter.enum';

export default defineComponent({

    extends: ComponentBase,

    components: {

        PageHeader,

        ExportDataModal,

        NDatePicker,
        NButton,
        NButtonGroup,
    },

    data() {


        const data = {
            DispatchDashboardFilterEnum,
            isLoading: false,
            avoltaConnectLogo: require('@/avolta-connect-logo.png').default,
            timerange:  [0,0],
            shortcuts: {},
            interval: null,
            now: moment(),
        }
        const now = moment().unix() * 1000;
        data.shortcuts[this.$t('advanced_view.last_month')] = [moment().subtract(1, 'month').unix() * 1000, now];
        data.shortcuts[this.$t('advanced_view.last_6_month')] = [moment().subtract(6, 'month').unix() * 1000, now];
        data.shortcuts[this.$t('advanced_view.last_quarter')] = [moment().subtract(3, 'month').unix() * 1000, now];
        data.shortcuts[this.$t('advanced_view.last_year')] = [moment().subtract(12, 'month').unix() * 1000, now];

        return data;
    },

    computed: {
        ...mapStores(useStationStore, useDispatchStore),
        ...mapState(useStationStore, ['groups', 'stations', 'group']),
        ...mapState(useDispatchStore, ['filter', 'since', 'before']),

        options(): SelectOption[] {
            if (!this.groups) {
                return [];
            }

            return this.groups.map((grp: StationGroup) => {
                return {
                    label: grp.label || grp.name,
                    value: grp.id,
                    // children: grp.stations.map((station: Station) => ({label: this.getStationName(station), value: station.id}))
                } as SelectOption
            });
        },
    },

    methods: {

        async refresh() {
            try {
                this.isLoading = true;
                // await this.stationStore.refresh();
                await this.dispatchStore.refresh();
            } catch (e) {
                this.$notifyError('Coud not refresh page', e);
            } finally {
                this.isLoading = false;
            }
        },

        onFilter(filter: DispatchDashboardFilterEnum) {
            this.$router.replace({ query: { filter }})
        },

        exportData() {
            //@ts-ignore
            this.$refs.export.open();
        }
    },
});